<template>
  <section class="language" ref="language" v-lock-body-scroll="open">
    <p class="current" @click="openCountryModal">
      <svg viewBox="0 0 20 20" class="earth">
        <path d="M10,0 C4.477125,0 0,4.477125 0,10 C0,12.3009583 0.77725,14.4202917 2.08333333,16.1100833 L2.08333333,16.2638333 C2.115125,16.253125 2.14727083,16.2427292 2.17922917,16.2321458 C4.0115,18.5284792 6.83383333,20 10,20 C13.2158125,20 16.0769375,18.4819583 17.90625,16.1235 C17.9097083,16.1246042 17.9132083,16.1256458 17.9166667,16.1267083 L17.9166667,16.1100833 C19.22275,14.4202917 20,12.3009583 20,10 C20,4.477125 15.522875,0 10,0 Z M19.1571875,9.58333333 L14.1585,9.58333333 C14.1315833,8.41847917 13.9933958,7.23479167 13.7336042,6.0300625 C15.1638125,5.84904167 16.5269167,5.56058333 17.7984792,5.18025 C18.59725,6.47 19.085125,7.97254167 19.1571875,9.58333333 Z M6.6719375,9.58333333 C6.6998125,8.42214583 6.84425,7.25927083 7.1051875,6.08070833 C8.11102083,6.19172917 9.148125,6.25 10.2083333,6.25 C11.1260833,6.25 12.0263125,6.20610417 12.903875,6.12214583 C13.1590625,7.28652083 13.3005,8.43577083 13.3280625,9.58333333 L6.6719375,9.58333333 Z M13.3280625,10.4166667 C13.2972708,11.6980208 13.1245625,12.9814375 12.8100208,14.2857083 C11.9621667,14.2075208 11.0933958,14.1666667 10.2083333,14.1666667 C9.18129167,14.1666667 8.17591667,14.2213333 7.1996875,14.3256667 C6.87897917,13.0076458 6.70302083,11.7111042 6.6719375,10.4166667 L13.3280625,10.4166667 Z M17.31125,4.47022917 C16.1294375,4.8044375 14.8652917,5.05783333 13.540875,5.21802083 C13.1883125,3.85764583 12.68025,2.47027083 12.0024167,1.05291667 C14.1555833,1.53272917 16.0231875,2.76977083 17.31125,4.47022917 Z M10,0.833333333 C10.3598958,0.833333333 10.7148958,0.854270833 11.0639792,0.894625 C11.7821875,2.40895833 12.3298958,3.87104167 12.7071042,5.30566667 C11.8928958,5.37858333 11.0584583,5.41666667 10.2083333,5.41666667 C9.21620833,5.41666667 8.24545833,5.36483333 7.30345833,5.26604167 C7.6803125,3.84408333 8.22445833,2.39497917 8.9360625,0.8945625 C9.285125,0.854208333 9.640125,0.833333333 10,0.833333333 Z M7.99764583,1.05272917 C7.32845833,2.452 6.824875,3.82202083 6.472875,5.16570833 C5.16816667,4.9873125 3.92527083,4.71791667 2.76583333,4.36991667 C4.05079167,2.72110417 5.88702083,1.52304167 7.99764583,1.05272917 Z M2.26795833,5.07460417 C3.5190625,5.47070833 4.86397917,5.77639583 6.27795833,5.97664583 C6.01070833,7.19979167 5.8688125,8.40127083 5.8415,9.58333333 L0.8428125,9.58333333 C0.916854167,7.92835417 1.42985417,6.387625 2.26795833,5.07460417 Z M2.4991875,15.2702292 C1.52452083,13.8855 0.9234375,12.2188333 0.8428125,10.4166667 L5.84102083,10.4166667 C5.87139583,11.7778958 6.05285417,13.1136458 6.36847917,14.4274792 C5.00827083,14.6153958 3.71116667,14.9006667 2.4991875,15.2702292 Z M3.04085417,15.9663125 C4.15325,15.6478958 5.33925,15.401125 6.58035417,15.2366042 C6.93654167,16.4920833 7.4139375,17.727875 7.99747917,18.947125 C6.03325,18.509375 4.30660417,17.4414167 3.04085417,15.9663125 Z M8.93604167,19.1054167 C8.2919375,17.7472917 7.78491667,16.4311875 7.4150625,15.1391875 C8.3220625,15.0478333 9.25533333,15 10.2083333,15 C11.0196875,15 11.8167917,15.0346875 12.5956875,15.1011875 C12.2249167,16.4053958 11.714375,17.7339792 11.0639375,19.1054583 C10.714875,19.1458125 10.359875,19.1666667 10,19.1666667 C9.64010417,19.1666667 9.28510417,19.14575 8.93604167,19.1054167 Z M12.0025625,18.9470417 C12.5939375,17.711375 13.0761875,16.45875 13.4338542,15.185875 C14.6960208,15.3333125 15.9042917,15.5653125 17.0396042,15.87125 C15.7670417,17.3954792 14.0087292,18.4999375 12.0025625,18.9470417 Z M17.5707292,15.1695417 C16.337875,14.8144583 15.0217292,14.5451875 13.6440625,14.3754792 C13.9520208,13.0784167 14.1290208,11.7599583 14.1590208,10.4166875 L19.1572083,10.4166875 C19.0785,12.1753542 18.5041875,13.8050417 17.5707292,15.1695417 Z"></path>
      </svg>
      <span>{{ language }}</span>
    </p>


    <a-modal 
     :getContainer="()=>$refs.language"
      v-model:visible="open" 
      :title="t('select_country.title')" 
      @ok="closeModal"
      :footer="null"
    >
      <template #closeIcon>
        <jds-icon name="close-fill" class="text-#999 hover:text-#666 transition-all duration-300 text-48 lg:a-text-32"></jds-icon>
      </template>
      <ul class="country-body">
        <li
          v-for="item in lists" 
          class="country-item">
          <div class="country-item__area-title">{{item.continent}}</div>
          <ul class="country-item__area-list">
            <li
              v-for="area in item.child" 
              class="country-item__area-item"
              :class="{'active': currentShopID === area.shopify_shop_id}"
              :data-country="area.official_country"
              :data-locale="area.official_language"
              @click="changeCountry(area)"
              >
        
              <span class="country-item__area-country">
                <svg v-if="loading === area.official_country" focusable="false" class="anticon-spin" width="1em" fill="currentColor" viewBox="0 0 1024 1024"><path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path></svg>
                {{area.official_country}}
                <i v-if="area.saleShow" class="w-24 h-24 ml-10 lg:a-w-12 lg:a-h-12 lg:a-ml-10 inline-block" style="background: url(&quot;https://cdn.shopify.com/s/files/1/0550/0524/9633/files/car-icon-mb.svg?v=1700637746&quot;) center center / cover no-repeat;"></i>
              </span>
              
              <span class="country-item__area-lang">{{area.official_language}}</span>
            </li>
          </ul>
        </li>
      </ul>
    </a-modal>
  </section>
</template>

<script setup>
  import { ref, reactive } from 'vue';
  import { useStore } from 'vuex';
  import {toggleLocalByCr} from "@u/helpers/app"
  import {shopifyLogin} from "@a/userCommon"
  import { getIDToken } from "@u/helpers/auth"

  const props = defineProps({
    position: String
  })

  const store = useStore();
  const open = ref(false);
  const loading = ref('');
  const { t } = useI18n();

  const language = computed({
    get: () => props.position !== "header" ? `${store.getters.language.current.official_country || ''} (${store.getters.language.current.official_language || ''})` : store.getters.language.current.cr,
    set: () => {}
  });
  const lists = computed(() => store.getters.language.lists);
  const currentShopID = computed(() => store.getters.language.current.shopify_shop_id);

  const showModal = () => {
    loading.value = ''
    open.value = true;
  }

  const closeModal = (e) => {
      loading.value = ''
      open.value = false;
  }

  const openCountryModal = () => {
    showModal()
  }

  const changeCountry = async (item) => {
    if(item.is_show) {
      await toggleLocalByCr(item.cr);
      if(props.position === "header") {
        if(getIDToken()) {
          loading.value = item.official_country
          shopifyLogin({
            return_url: location.href,
            shop_id: item.shop_id,
            token: getIDToken()
          }).then(res => {
            location.href = res.redirect_url
          }).catch(() => {
            location.reload()
          }).finally(() => {
            closeModal();
          })
        } else {
          // closeModal();
          location.reload()
        }
      } else {
        closeModal();
      }
    } else {
      window.open(item.domain);
    }
  }
</script>

<style scoped lang="less">
 .language {
  :deep(.ant-modal) {
    width: 960px!important;
    .ant-modal-title {
      font-weight: 600;
      text-align: center;
    }
  }

  .country-body {
    text-align: left;
    .country-item {
      margin-bottom: 32px;
    }
    .country-item__area-title {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 8px;
    }

    .country-item__area-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      .country-item__area-item {
        background-color: #f7f9fa;
        height: 48px;
        width: 294px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        cursor: pointer;
        transition: all .3s ease;
        justify-content: space-between;
        .country-item__area-lang {
          color: #9fa3a6;
          font-weight: 400;
          transition: color .3s ease;
        }
        &:hover, &.active, &:active {
          color: #ff5000;
          .country-item__area-lang {
            color: #ff5000;
          }
        }
      }
    }
  }
 }
 @media screen and (max-width: 1024px) {
  .language :deep(.ant-modal) {
    width: 100%!important;
    max-width: 100%;
    top: 0;
    margin: 0;
    padding-bottom: 0;
    position: relative;
    .ant-modal-title {
      font-weight: 600;
      text-align: center;
    }
    .ant-modal-header {
      position: sticky;
      top: 0;
    }
  }

  .language .country-body {
    .country-item {
      margin-bottom: 16px;
    }
    .country-item__area-list {
      .country-item__area-item {
        width: 100%;
        padding: 0 16px;
      }
    }
  }
 }



  .language {
    text-align: right; color: var(--regular-color); flex-direction: row-reverse;
    .earth {width: 20px; height: 20px; margin-right: 7px; fill: currentColor; cursor: pointer; display: inline-block;}
    .current {cursor: pointer; display: flex; align-items: center; position: relative;}
  }

  @media screen and (min-width: 541px) {
    .language {position: absolute; right: 0; bottom: 26px; z-index: 10;}
  }

  @media screen and (max-width: 1280px) {
    .language {bottom: 6px;}
  }

  @media screen and (max-width: 540px) {
    .language {
      --distance: 80px;
      width: 100%; margin: var(--gap) 0; position: relative;
      .earth {width: 16px; height: 16px;}
      input {width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 1; opacity: 0;}
      .current {justify-content: center;}
    }
  }
</style>
